import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {}
const files = require.context('./', true, /\.js$/)

let fileObj = null

files.keys().forEach(filePath => {
  if (filePath === './index.js') return

  fileObj = filePath.replace('.js', '').split('/')

  if (!messages[fileObj[1]])
    messages[fileObj[1]] = {}

  messages[fileObj[1]][fileObj[2]] = files(filePath).default
})

const vue18n = new VueI18n({
  locale: 'de',
  messages
})

export default vue18n



// WEBPACK FOOTER //
// ./src/lang/index.js